var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5303 7.53026C16.2374 7.82315 15.7626 7.82315 15.4697 7.53026L10.75 2.81058L10.75 13.9999C10.75 14.4141 10.4142 14.7499 10 14.7499C9.58578 14.7499 9.25 14.4141 9.25 13.9999L9.25 2.81059L4.53033 7.53025C4.23744 7.82315 3.76256 7.82315 3.46967 7.53025C3.17678 7.23736 3.17678 6.76249 3.46967 6.46959L9.11612 0.823148C9.60427 0.334992 10.3957 0.334992 10.8839 0.823148L16.5303 6.46959C16.8232 6.76249 16.8232 7.23736 16.5303 7.53026Z",
    fill: "#1D79F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 12.9999C1.75 12.5857 1.41421 12.2499 1 12.2499C0.585786 12.2499 0.25 12.5857 0.25 12.9999V14.9999C0.25 17.071 1.92893 18.7499 4 18.7499H16C18.0711 18.7499 19.75 17.071 19.75 14.9999V12.9999C19.75 12.5857 19.4142 12.2499 19 12.2499C18.5858 12.2499 18.25 12.5857 18.25 12.9999V14.9999C18.25 16.2426 17.2426 17.2499 16 17.2499H4C2.75736 17.2499 1.75 16.2426 1.75 14.9999V12.9999Z",
    fill: "#1D79F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c065c6caeb824f64a15b376fbe215d7b.svg";
export { ForwardRef as ReactComponent };